import { useState, useEffect } from "react";
import {
  Typography,
  Divider,
  Input,
  Select,
  Card,
  Row,
  Col,
  Form,
  Button,
  Modal,
} from "antd";
import {
  MinusCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { useLookups } from "./hooks/useLookups";
import InstitutionPicker from "../custom/InstitutionPicker";

import { util } from '@seims/shared';

const ProfExperienceForm = ({ onSave, initialValues, onCancel }) => {
  const [selectedQualification, setSelectedQualification] = useState("");
  const [selectedOccupation, setSelectedOccupation] = useState("");
  const [selectedSector, setSelectedSector] = useState("");
  const [selectedInstitution, setSelectedInstitution] = useState("");
  const [selectedEmploymentStatus, setSelectedEmploymentStatus] = useState("");
  const [showOccupation, setShowOccupation] = useState(false);
  const [showProfBodies, setShowProfBodies] = useState(false)

  const { Text } = Typography;
  const { Option } = Select;
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const { confirm } = Modal;

  const {
    qualifications,
    occupations,
    employmentSectors,
    participantRoles,
    employmentStatus,
  } = useLookups();

  const { data: rolesList } = participantRoles;

  useEffect(() => {
    if (initialValues && initialValues.qualifications?.length > 0) {
      const remapQualifications = initialValues.qualifications.map((item) => ({
        qualification: qualifications?.data?.find(
          (c) => c.key === item.qualification.key
        ),
        institution: item.institution,
        field: item.field,
      }));

      setSelectedEmploymentStatus(initialValues.employmentStatus?.key);

      if (initialValues.employmentStatus) {
        showOccupationSection(initialValues.employmentStatus?.key);
      }

      form.setFieldsValue({
        specialisation: initialValues.specialisation,
        qualifications: remapQualifications,
        organisations: initialValues.organisations,
        occupation: initialValues.occupation,
        employment: initialValues.employment,
        employmentStatus: initialValues.employmentStatus,
        about: initialValues.about,
        linkedIn: initialValues.linkedIn,
        website: initialValues.website,
      });
    }
  }, [
    initialValues && initialValues.qualifications?.length > 0,
    qualifications?.data?.length > 0,
    employmentStatus?.data?.length > 0,
  ]);

  const handleQualificationChange = (selected, index) => {
    const qualificationList = form.getFieldValue("qualifications") || [];
    qualificationList[index] = {
      ...qualificationList[index],
      qualification: qualifications.data?.find((c) => c.key == selected),
    };

    form.setFieldsValue({
      qualificationList,
    });
  };

  const handleRoleChange = (selected, index) => {
    const selectedRoleItem = form.getFieldValue("organisations") || [];
    selectedRoleItem[index] = {
      ...selectedRoleItem[index],
      role: rolesList.data?.find((c) => c.key == selected),
    };

    form.setFieldsValue({
      selectedRoleItem,
    });
  };

  const handleOccupation = (selected) => {
    const occupation = occupations.data?.find((c) => c.key == selected);
    form.setFieldsValue({ occupation: occupation });
  };

  const handleSector = (selected) => {
    const employment = employmentSectors.data?.find((c) => c.key == selected);
    form.setFieldsValue({ employment: employment });
  };

  const handleRole = () => {};
  const onFinishFailed = () => {};

  const showOccupationSection = (selected) => {
    const employmentstatus = employmentStatus?.data?.find(
      (c) => c.key == selected
    );

    if (
      ["unemployed", "retired"].includes(
        employmentstatus?.value.toString().toLowerCase()
      )
    )
      setShowOccupation(false);
    else setShowOccupation(true);

    return employmentStatus;
  };

  const handleEmploymentStatus = (selected) => {
    // const employmentstatus = showOccupationSection(selected);
    const selectedStatus = employmentStatus.data?.find(
      (c) => c.key == selected
    );

    if (
      ["unemployed", "retired"].includes(
        selectedStatus.value.toString().toLowerCase()
      )
    )
      setShowOccupation(false);
    else setShowOccupation(true);

    setSelectedEmploymentStatus(selected);
    form.setFieldsValue({ employmentstatus: selectedStatus });
  };

  // Cancel Confirmation Logic
  const showCancelConfirm = () => {
    confirm({
      title: "Are you sure you want to cancel?",
      icon: <ExclamationCircleOutlined />,
      content:
        "Any unsaved changes will be lost. This action cannot be undone.",
      okText: "Yes, Cancel",
      okType: "danger", // Make the "Yes, Cancel" button red
      cancelText: "No, Keep Editing",
      onOk() {
        form.resetFields(); // Reset form fields to initial values (set by useEffect)
        onCancel(); // Call the parent's onCancel to change view
      },
      onCancel() {
        // This code runs if the user clicks "No, Keep Editing" or closes the modal
      },
    });
  };

  // This assumes 'form' is accessible and 'organisations' is the name of the Form.List.
// Get the current array of organizations from the form state.
const organisations = form.getFieldValue('organisations');

// Determine if the title should be shown: show if there are items, or if the user is actively adding.
const shouldShowTitle = organisations && organisations.length > 0;

  const onFinish = async (values) => {
    let qual = [];
    let orgs = [];
    let userData = { ...values };
    userData.qualifications.map((q) => {
      qual.push({
        qualification: q.qualification.key,
        institution: q.institution,
        field: q.field,
      });
    });
    userData.organisations.map((q) => {
      orgs.push({
        organisation: q.organisation,
        role: q.role,
      });
    });
    userData.qualifications = qual;
    userData.organisations = orgs;

    const selectedEmploymentStatus = employmentStatus?.data?.find(
      (c) => c.key == userData.employmentStatus.key
    );

    userData.occupation = userData.occupation?.key;
    userData.employment = userData.employment?.key;
    userData.employmentStatus = isNaN(parseInt(userData.employmentStatus))
      ? selectedEmploymentStatus.key
      : parseInt(userData.employmentStatus);
    userData.id = initialValues.id;
    onSave(userData);
  };

  const onNameBlur = (e, index, section = "qualifications") => {
    const { value, name } = e.target;
    const textValue = util.toPascalText(value);
    var selectedOption = [];

    if (section == "qualifications") {
      selectedOption = form.getFieldValue("qualifications") || [];
    } else if (section == "organisations") {
      selectedOption = form.getFieldValue("organisations") || [];
    } else {
      form.setFieldsValue({
        [name]: textValue,
      });
      return;
    }
    selectedOption[index] = {
      ...selectedOption[index],
      [name]: textValue,
    };

    form.setFieldsValue({
      selectedOption,
    });
  };

  const onSelectedInstitution = (selectedValue, index, section) => {
    var selectedOption = [];
    selectedOption = form.getFieldValue(section) || [];

    selectedOption[index] = {
      ...selectedOption[index],
      institution: selectedValue,
    };

    form.setFieldsValue({
      qualifications: selectedOption,
    });

    setSelectedInstitution(selectedValue);
  };

  const handleUrlChange = (e) => {
    const { value, name } = e.target;

    if (value.length === 1) {
      if (name == "linkedIn") {
        form.setFieldsValue({ [name]: `https://linkedin.com/${value}` });
      } else {
        form.setFieldsValue({ [name]: `https://${value}` });
      }
    } else {
      form.setFieldsValue({ [name]: `${value}` });
    }
  };

  const validateURL = (value) => {
    if (!value) return Promise.resolve();
    try {
      const url = new URL(value);
      if (url.protocol === "http:" || url.protocol === "https:") {
        return Promise.resolve();
      } else {
        return Promise.reject(
          "A valid URL must start with http:// or https://"
        );
      }
    } catch {
      return Promise.reject("Please enter a valid URL");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "0px",
        width: "100%",
      }}
    >
      <Card
        title={<h2 className="card-head-title">PROFESSIONAL EXPERIENCE</h2>}
        className="card-main"
        style={{ maxWidth: "1000px", marginBottom: "40px" }}
      >
        <Form
          form={form}
          name="prof_experience"
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{ qualifications: [{}], organisations: [{}] }}
        >
          <Row>
            <Col>
              <Text strong>Qualification(s)</Text>
            </Col>
          </Row>
          <Form.List name="qualifications">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, field, name, index, ...restField }) => (
                  <Row gutter={[20, 20]} key={key}>
                    <Col xs={22} sm={23} md={6}>
                      <Form.Item
                        {...restField}
                        name={[name, "qualification"]}
                        label="Qualification"
                        rules={[
                          { required: true, message: "Please select a qualification" },
                        ]}
                      >
                        <Select
                          value={selectedQualification}
                          onChange={(value) => handleQualificationChange(value, [name])}
                        >
                          {qualifications?.data?.map((option) => (
                            <Option key={option.key}>{option.value}</Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={22} sm={23} md={8}>
                      <Form.Item
                        {...restField}
                        name={[name, "field"]}
                        label="Field of Study"
                        rules={[
                          { required: true, message: "Please select field of study" },
                        ]}
                      >
                        <Input
                          name="field"
                          onBlur={(value) => onNameBlur(value, name, "qualifications")}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={22} sm={23} md={8}>
                      <Form.Item
                        {...restField}
                        name={[name, "institution"]}
                        label="Institution of Study"
                        rules={[
                          {
                            required: true,
                            message: "Please select an institution of study",
                          },
                        ]}
                      >
                        <InstitutionPicker
                          key={[name]}
                          width=""
                          name="institution"
                          onSelectedInstitution={(value) =>
                            onSelectedInstitution(value, name, "qualifications")
                          }
                          placeholder={"Start typing to see options"}
                          form={form}
                          value={selectedInstitution}
                        />
                      </Form.Item>
                    </Col>

                    {/* Only show remove if there is more than 1 qualification */}
                    {fields.length > 1 && (
                      <Col xs={1} sm={1} md={2} style={{ paddingTop: "32px" }}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Col>
                    )}
                  </Row>
                ))}

                <Form.Item>
                  <Col xs={16} sm={8} md={6}>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      className="add-more-button"
                    >
                      Add another qualification
                    </Button>
                  </Col>
                </Form.Item>
              </>
            )}
          </Form.List>

          <Divider variant="dashed" dashed />
          <Row>
            <Col>
              <Text strong>Employment Status</Text>
            </Col>
          </Row>
          <Row gutter={[20, 20]}>
            <Col xs={24} sm={12} md={6}>
              <Form.Item
                name={"employmentStatus"}
                label="Employment Status"
                rules={[
                  {
                    required: true,
                    message: "Please select an employment status",
                  },
                ]}
              >
                <Select
                  value={selectedEmploymentStatus}
                  onChange={handleEmploymentStatus}
                >
                  {employmentStatus?.data?.map((option) => (
                    <Option key={option.key}>{option.value}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {showOccupation && (
            <>
              <Divider variant="dashed" dashed />

              <Row>
                <Col>
                  <Text strong>Occupation</Text>
                </Col>
              </Row>
              <Row gutter={[20, 20]}>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item
                    name={"occupation"}
                    label="Occupation"
                    rules={[
                      {
                        required: true,
                        message: "Please select an occupation",
                      },
                    ]}
                  >
                    <Select
                      value={selectedOccupation}
                      onChange={handleOccupation}
                    >
                      {occupations?.data?.map((option) => (
                        <Option key={option.key}>{option.value}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name={"employment"}
                    label="Employment Sector"
                    rules={[
                      {
                        required: true,
                        message: "Please select employment sector",
                      },
                    ]}
                  >
                    <Select value={selectedSector} onChange={handleSector}>
                      {employmentSectors?.data?.map((option) => (
                        <Option key={option.key}>{option.value}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="specialisation"
                    label="Area of Specialisation"
                    rules={[
                      {
                        required: true,
                        message: "Please enter area of specialisation",
                      },
                    ]}
                  >
                    <Input
                      name="specialisation"
                      onBlur={(value) =>
                        onNameBlur(value, "specialisation", "occupation")
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          <Divider variant="dashed" dashed />
          <Form.List name="organisations">
            {(fields, { add, remove }) => {
              // Check if there are any valid fields (either pre-populated or actively being edited)
              const hasData = fields.length > 0;
              return (
                <>
                  {/* Conditional Title Row */}
                  {hasData && (
                    <Row>
                      <Col>
                        <Text strong>Professional Bodies or Volunteer Associations</Text>
                      </Col>
                    </Row>
                  )}

                  {/* Mapped Fields (Always rendered if hasData is true) */}
                  {fields.map(({ key, name, ...restField }) => (
                    // ... (Mapping logic for existing fields)
                    <Row gutter={[20, 20]} key={key}>
                      <Col xs={22} sm={11} md={8}>
                        <Form.Item
                          {...restField}
                          name={[name, "organisation"]}
                          label="Name"
                          rules={[
                            {
                              required: false,
                              message: "Please enter an organisation",
                            },
                          ]}
                        >
                          <Input name="organisation" onBlur={(value) => onNameBlur(value, name, "organisations")} />
                        </Form.Item>
                      </Col>
                      <Col xs={22} sm={11} md={8}>
                        <Form.Item
                          {...restField}
                          name={[name, "role"]}
                          label="Role"
                          rules={[
                            {
                              required: false,
                              message: "Please specify a role",
                            },
                          ]}
                        >
                          <Input name="role" onBlur={(value) => onNameBlur(value, name, "organisations")} />
                        </Form.Item>
                      </Col>

                      {fields.length > 1 && (
                        <Col xs={1} sm={1} md={1} style={{ paddingTop: "35px" }}>
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </Col>
                      )}

                    </Row>
                  ))}

                  {/* The 'Add another affiliation' button remains visible */}
                  <Form.Item>
                    <Col xs={16} sm={8} md={6}>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        block
                        className="add-more-button"
                      >
                        Add another professional body
                      </Button>
                    </Col>
                  </Form.Item>
                </>
              );
            }}
          </Form.List>
          <Divider variant="dashed" dashed />
          <Row>
            <Col>
              <Text strong>Tell us about yourself</Text>
            </Col>
          </Row>
          <Row gutter={[20, 20]}>
            <Col xs={24} sm={24} md={16}>
              <Form.Item name={"about"} label="">
                <TextArea
                  name="about"
                  placeholder="What are your areas of specialisation? Which province/city would you be open to volunteering in? Do you have any previous volunteer experience that you can share?"
                  rows={4}
                  showCount
                  maxLength={500}
                  minLength={5}
                />
              </Form.Item>
            </Col>
          </Row>
          <Divider variant="dashed" dashed />
          <Row>
            <Col>
              <Text strong>Links</Text>
            </Col>
          </Row>
          <Row gutter={[20, 20]}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                name={"linkedIn"}
                label="Linkedin URL"
                onChange={handleUrlChange}
                rules={[
                  {
                    validator: (_, value) => validateURL(value),
                  },
                ]}
              >
                <Input name={"linkedIn"} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                name={"website"}
                label="Website URL"
                onChange={handleUrlChange}
                rules={[
                  {
                    validator: (_, value) => validateURL(value),
                  },
                ]}
              >
                <Input name={"website"} />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            style={{
              textAlign: "right",
              marginTop: "24px",
              marginBottom: "0px",
            }}
          >
            <Button
              onClick={showCancelConfirm}
              className="secondary-volunteer-button"
              style={{ marginRight: "8px" }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              className="primary-volunteer-button"
              htmlType="submit"
            >
              Save
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ProfExperienceForm;
